import type { SVGProps } from "react";

export function IconUsa(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FCF0F0" />
      <g clipPath="url(#clip0_6963_20690)">
        <path
          d="M28 44C36.8366 44 44 36.8366 44 28C44 19.1634 36.8366 12 28 12C19.1634 12 12 19.1634 12 28C12 36.8366 19.1634 44 28 44Z"
          fill="#F0F0F0"
        />
        <path
          d="M27.3037 27.9996H43.9993C43.9993 26.5555 43.8068 25.1565 43.4481 23.8257H27.3037V27.9996Z"
          fill="#D80027"
        />
        <path
          d="M27.3037 19.652H41.651C40.6715 18.0537 39.4192 16.641 37.9591 15.478H27.3037V19.652Z"
          fill="#D80027"
        />
        <path
          d="M27.9998 43.9997C31.7654 43.9997 35.2264 42.6982 37.9595 40.5215H18.04C20.7732 42.6982 24.2342 43.9997 27.9998 43.9997Z"
          fill="#D80027"
        />
        <path
          d="M14.348 36.3478H41.6512C42.4375 35.0647 43.0473 33.6622 43.4484 32.1738H12.5508C12.9518 33.6622 13.5617 35.0647 14.348 36.3478Z"
          fill="#D80027"
        />
        <path
          d="M19.4115 14.4986H20.8696L19.5133 15.4839L20.0314 17.0782L18.6752 16.0929L17.319 17.0782L17.7665 15.7009C16.5724 16.6956 15.5257 17.861 14.6632 19.1595H15.1304L14.2671 19.7867C14.1326 20.0111 14.0036 20.239 13.88 20.4703L14.2922 21.7391L13.5231 21.1803C13.3319 21.5854 13.1571 21.9996 12.9999 22.4224L13.4541 23.8204H15.1304L13.7742 24.8057L14.2922 26.4L12.9361 25.4147L12.1237 26.0049C12.0424 26.6586 12 27.3243 12 28H28C28 19.1635 28 18.1217 28 12C24.8393 12 21.8928 12.9169 19.4115 14.4986ZM20.0314 26.4L18.6752 25.4147L17.319 26.4L17.8371 24.8057L16.4808 23.8204H18.1572L18.6752 22.2261L19.1932 23.8204H20.8696L19.5133 24.8057L20.0314 26.4ZM19.5133 20.1448L20.0314 21.7391L18.6752 20.7538L17.319 21.7391L17.8371 20.1448L16.4808 19.1595H18.1572L18.6752 17.5652L19.1932 19.1595H20.8696L19.5133 20.1448ZM25.7705 26.4L24.4143 25.4147L23.0581 26.4L23.5762 24.8057L22.2199 23.8204H23.8963L24.4143 22.2261L24.9323 23.8204H26.6087L25.2524 24.8057L25.7705 26.4ZM25.2524 20.1448L25.7705 21.7391L24.4143 20.7538L23.0581 21.7391L23.5762 20.1448L22.2199 19.1595H23.8963L24.4143 17.5652L24.9323 19.1595H26.6087L25.2524 20.1448ZM25.2524 15.4839L25.7705 17.0782L24.4143 16.0929L23.0581 17.0782L23.5762 15.4839L22.2199 14.4986H23.8963L24.4143 12.9043L24.9323 14.4986H26.6087L25.2524 15.4839Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_6963_20690">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
